<template>
  <div>
    <header class="section privacy-header">
      <div class="container">
        <div class="columns header">
          <div class="column is-full has-text-centered">
            <h1 class="title is-1">Privacy Policy</h1>
            <p class="subtitle has-text-weight-medium">
              Last updated: August 17, 2020
            </p>
          </div>
        </div>
      </div>
    </header>
    <section class="section details">
      <div class="container py-4">
        <div
          class="columns is-mobile is-centered has-text-black-ter has-text-weight-medium"
        >
          <div class="column is-10">
            <!-- {{ data.content }} -->
            <div v-html="data.content"></div>
            <!-- <div>
              <p>
                This Privacy Policy describes Our policies and procedures on the
                collection, use and disclosure of Your information when You use
                the Service and tells You about Your privacy rights and how the
                law protects You.
              </p>
              <p>
                We use Your Personal data to provide and improve the Service. By
                using the Service, You agree to the collection and use of
                information in accordance with this Privacy Policy.
              </p>
            </div>
            <div>
              <h3 class="title is-3 mt-5">Interpretation and Definitions</h3>
              <h4 class="title is-4 mt-4">Interpretation</h4>
              <p>
                The words of which the initial letter is capitalized have
                meanings defined under the following conditions. The following
                definitions shall have the same meaning regardless of whether
                they appear in singular or in plural.
              </p>
              <h4 class="title is-4 mt-4">Definitions</h4>
              <p>For the purposes of this Privacy Policy:</p>
              <ol type="I">
                <li>
                  <strong>Account</strong> means a unique account created for
                  You to access our Service or parts of our Service.
                </li>
                <li>
                  <strong>Business</strong>, for the purpose of the CCPA
                  (California Consumer Privacy Act), refers to the Company as
                  the legal entity that collects Consumers' personal information
                  and determines the purposes and means of the processing of
                  Consumers' personal information, or on behalf of which such
                  information is collected and that alone, or jointly with
                  others, determines the purposes and means of the processing of
                  consumers' personal information, that does business in the
                  State of California.
                </li>
                <li>
                  <strong>Company</strong>
                  &nbsp;(referred to as either "the Company", "We", "Us" or
                  "Our" in this Agreement) refers to KidsTopia INC, 14725 S
                  Porter Rockwell Blvd, STE K, Bluffdale, UT 84065.
                </li>
                <li>
                  <strong>Customer</strong>, for the purpose of the CCPA
                  (California Consumer Privacy Act), means a natural person who
                  is a California resident. A resident, as defined in the law,
                  includes (1) every individual who is in the USA for other than
                  a temporary or transitory purpose, and (2) every individual
                  who is domiciled in the USA who is outside the USA for a
                  temporary or transitory purpose.
                </li>
                <li>
                  <strong>Cookies</strong> are small files that are placed on
                  Your computer, mobile device or any other device by a website,
                  containing the details of Your browsing history on that
                  website among its many uses.
                </li>
                <li>
                  <strong>Device</strong>&nbsp;means any device that can access
                  the Service such as a computer, a cellphone or a digital
                  tablet.
                </li>
                <li>
                  <strong>Do Not Track</strong>&nbsp;(DNT) is a concept that has
                  been promoted by US regulatory authorities, in particular the
                  U.S. Federal Trade Commission (FTC), for the Internet industry
                  to develop and implement a mechanism for allowing internet
                  users to control the tracking of their online activities
                  across websites.
                </li>
                <li>
                  <strong>Personal Data</strong>&nbsp;is any information that
                  relates to an identified or identifiable individual.
                  <ul>
                    <li>
                      For the purposes of the CCPA, Personal Data means any
                      information that identifies, relates to, describes or is
                      capable of being associated with, or could reasonably be
                      linked, directly or indirectly, with You.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Sale</strong>, for the purpose of the CCPA (California
                  Consumer Privacy Act), means selling, renting, releasing,
                  disclosing, disseminating, making available, transferring, or
                  otherwise communicating orally, in writing, or by electronic
                  or other means, a Consumer's Personal information to another
                  business or a third party for monetary or other valuable
                  consideration.
                </li>
                <li><strong>Service</strong>&nbsp;refers to the Website.</li>
                <li>
                  <strong>Service Provider</strong>&nbsp;means any natural or
                  legal person who processes the data on behalf of the Company.
                  It refers to third-party companies or individuals employed by
                  the Company to facilitate the Service, to provide the Service
                  on behalf of the Company, to perform services related to the
                  Service or to assist the Company in analyzing how the Service
                  is used.
                </li>
                <li>
                  <strong>Third-party Social Media Service</strong>&nbsp;refers
                  to any website or any social network website through which a
                  User can log in or create an account to use the Service.
                </li>
                <li>
                  <strong>Usage Data</strong>&nbsp;refers to data collected
                  automatically, either generated by the use of the Service or
                  from the Service infrastructure itself (for example, the
                  duration of a page visit).
                </li>
                <li>
                  <strong>Website</strong>&nbsp;refers to KidsTopia, accessible
                  from&nbsp;<a href="https://kidstopia-us.com"
                    >https://kidstopia-us.com</a
                  >
                </li>
                <li>
                  <strong>You</strong>&nbsp;means the individual accessing or
                  using the Service, or the company, or other legal entity on
                  behalf of which such individual is accessing or using the
                  Service, as applicable.
                </li>
              </ol>
            </div>
            <div>
              <h3 class="title is-3 mt-5">
                Collecting and Using Your Personal Data
              </h3>
              <h4 class="title is-4 mt-4">Types of Data Collected</h4>
              <h5 class="title is-5 mt-3">Personal Data</h5>
              <p>
                While using Our Service, We may ask You to provide Us with
                certain personally identifiable information that can be used to
                contact or identify You. Personally identifiable information may
                include, but is not limited to:
              </p>
              <ol type="I">
                <li>Email address</li>
                <li>First name and last name</li>
                <li>Phone number</li>
                <li>Address, State, Province, ZIP/Postal code, City</li>
                <li>Usage Data</li>
              </ol>
              <h5 class="title is-5 mt-3">Usage Data</h5>
              <p>
                Usage Data is collected automatically when using the Service.
              </p>
              <p>
                Usage Data may include information such as Your Device's
                Internet Protocol address (e.g. IP address), browser type,
                browser version, the pages of our Service that You visit, the
                time and date of Your visit, the time spent on those pages,
                unique device identifiers and other diagnostic data.
              </p>
              <p>
                When You access the Service by or through a mobile device, We
                may collect certain information automatically, including, but
                not limited to, the type of mobile device You use, Your mobile
                device unique ID, the IP address of Your mobile device, Your
                mobile operating system, the type of mobile Internet browser You
                use, unique device identifiers and other diagnostic data.
              </p>
              <p>
                We may also collect information that Your browser sends whenever
                You visit our Service or when You access the Service by or
                through a mobile device.
              </p>
              <h5 class="title is-5 mt-3">Tracking Technologies and Cookies</h5>
              <p>
                We use Cookies and similar tracking technologies to track the
                activity on Our Service and store certain information. Tracking
                technologies used are beacons, tags, and scripts to collect and
                track information and to improve and analyze Our Service.
              </p>
              <p>
                You can instruct Your browser to refuse all Cookies or to
                indicate when a Cookie is being sent. However, if You do not
                accept Cookies, You may not be able to use some parts of our
                Service.
              </p>
              <p>
                Cookies can be "Persistent" or "Session" Cookies. Persistent
                Cookies remain on your personal computer or mobile device when
                You go offline, while Session Cookies are deleted as soon as You
                close your web browser. Learn more about cookies:&nbsp;<a
                  href="https://www.termsfeed.com/blog/cookies/"
                  >All About Cookies</a
                >.
              </p>
              <p>
                We use both session and persistent Cookies for the purposes set
                out below:
              </p>
              <ol type="I">
                <li class="my-2">
                  <strong>Necessary / Essential Cookies</strong><br />
                  Type: Persistent Cookies<br />
                  Administered by: Us<br />
                  Purpose: These Cookies identify if users have accepted the use
                  of cookies on the Website.
                </li>
                <li class="my-2">
                  <strong>Cookies Policy / Notice Acceptance Cookies</strong
                  ><br />
                  Type: Persistent Cookies<br />
                  Administered by: Us<br />
                  Purpose: These Cookies identify if users have accepted the use
                  of cookies on the Website.
                </li>
                <li class="my-2">
                  <strong>Functionality Cookies</strong><br />
                  Type: Persistent Cookies<br />
                  Administered by: Us<br />
                  Purpose: These Cookies allow us to remember choices You make
                  when You use the Website, such as remembering your login
                  details or language preference. The purpose of these Cookies
                  is to provide You with a more personal experience and to avoid
                  You having to re-enter your preferences every time You use the
                  Website.
                </li>
                <li class="my-2">
                  <strong>Tracking and Performance Cookies</strong><br />
                  Type: Persistent Cookies<br />
                  Administered by: Third-Parties<br />
                  Purpose: These Cookies are used to track information about
                  traffic to the Website and how users use the Website. The
                  information gathered via these Cookies may directly or
                  indirectly identify you as an individual visitor. This is
                  because the information collected is typically linked to a
                  pseudonymous identifier associated with the device you use to
                  access the Website. We may also use these Cookies to test new
                  pages, features or new functionality of the Website to see how
                  our users react to them.
                </li>
              </ol>
              <p>
                For more information about the cookies we use and your choices
                regarding cookies, please visit our Cookies Policy or the
                Cookies section of our Privacy Policy.
              </p>
              <h4 class="title is-4 mt-4">Use of Your Personal Data</h4>
              <p>
                The Company may use Personal Data for the following purposes:
              </p>
              <ol type="I">
                <li>
                  <strong>To provide and maintain our Service</strong>,
                  including to monitor the usage of our Service.
                </li>
                <li>
                  <strong>To manage Your Account:</strong>&nbsp;to manage Your
                  registration as a user of the Service. The Personal Data You
                </li>
                provide can give You access to different functionalities of the
                Service that are available to You as a registered user.
                <li>
                  <strong>For the performance of a contract:</strong>&nbsp;the
                  development, compliance and undertaking of the purchase
                  contract
                </li>
                for the products, items or services You have purchased or of any
                other contract with Us through the Service.
                <li>
                  <strong>To contact You:</strong>&nbsp;To contact You by email,
                  telephone calls, SMS, or other equivalent forms of electronic
                </li>
                communication, such as a mobile application's push notifications
                regarding updates or informative communications related to the
                functionalities, products or contracted services, including the
                security updates, when necessary or reasonable for their
                implementation.
                <li>
                  <strong>To provide You</strong>&nbsp;with news, special offers
                  and general information about other goods, services and events
                </li>
                which we offer that are similar to those that you have already
                purchased or enquired about unless You have opted not to receive
                such information.
                <li>
                  <strong>To manage Your requests:</strong>&nbsp;To attend and
                  manage Your requests to Us.
                </li>
              </ol>
              <p>
                We may share your personal information in the following
                situations:
              </p>
              <ol type="I">
                <li>
                  <strong>With Service Providers:</strong>
                  We may share Your personal information with Service Providers
                  to monitor and analyze the use of our Service, to advertise on
                  third party websites to You after You visited our Service, to
                  contact You.
                </li>
                <li>
                  <strong>For Business transfers:</strong>&nbsp;We may share or
                  transfer Your personal information in connection with, or
                  during negotiations of, any merger, sale of Company assets,
                  financing, or acquisition of all or a portion of our business
                  to another company.
                </li>
                <li>
                  <strong>With Affiliates:</strong>&nbsp;We may share Your
                  information with Our affiliates, in which case we will require
                  those affiliates to honor this Privacy Policy. Affiliates
                  include Our parent company and any other subsidiaries, joint
                  venture partners or other companies that We control or that
                  are under common control with Us.
                </li>
                <li>
                  <strong>With Business partners:</strong>&nbsp;We may share
                  Your information with Our business partners to offer You
                  certain products, services or promotions.
                </li>
                <li>
                  <strong>With other users:</strong>&nbsp;when You share
                  personal information or otherwise interact in the public areas
                  with other users, such information may be viewed by all users
                  and may be publicly distributed outside. If You interact with
                  other users or register through a Third-Party Social Media
                  Service, Your contacts on the Third-Party Social Media Service
                  may see Your name, profile, pictures and description of Your
                  activity. Similarly, other users will be able to view
                  descriptions of Your activity, communicate with You and view
                  Your profile.
                </li>
              </ol>
              <h4 class="title is-4 mt-4">Retention of Your Personal Data</h4>
              <p>
                The Company will retain Your Personal Data only for as long as
                is necessary for the purposes set out in this Privacy Policy. We
                will retain and use Your Personal Data to the extent necessary
                to comply with our legal obligations (for example, if we are
                required to retain your data to comply with applicable laws),
                resolve disputes, and enforce our legal agreements and policies.
              </p>
              <p>
                The Company will also retain Usage Data for internal analysis
                purposes. Usage Data is generally retained for a shorter period
                of time, except when this data is used to strengthen the
                security or to improve the functionality of Our Service, or We
                are legally obligated to retain this data for longer time
                periods.
              </p>
              <h4 class="title is-4 mt-4">Transfer of Your Personal Data</h4>
              <p>
                Your information, including Personal Data, is processed at the
                Company's operating offices and in any other places where the
                parties involved in the processing are located. It means that
                this information may be transferred to — and maintained on —
                computers located outside of Your state, province, country or
                other governmental jurisdiction where the data protection laws
                may differ than those from Your jurisdiction.
              </p>
              <p>
                Your consent to this Privacy Policy followed by Your submission
                of such information represents Your agreement to that transfer.
              </p>
              <p>
                The Company will take all steps reasonably necessary to ensure
                that Your data is treated securely and in accordance with this
                Privacy Policy and no transfer of Your Personal Data will take
                place to an organization or a country unless there are adequate
                controls in place including the security of Your data and other
                personal information.
              </p>
              <h4 class="title is-4 mt-4">Disclosure of Your Personal Data</h4>
              <h5 class="title is-5 mt-3">Business Transactions</h5>
              <p>
                If the Company is involved in a merger, acquisition or asset
                sale, Your Personal Data may be transferred. We will provide
                notice before Your Personal Data is transferred and becomes
                subject to a different Privacy Policy.
              </p>
              <h5 class="title is-5 mt-3">Law enforcement</h5>
              <p>
                Under certain circumstances, the Company may be required to
                disclose Your Personal Data if required to do so by law or in
                response to valid requests by public authorities (e.g. a court
                or a government agency).
              </p>
              <h5 class="title is-5 mt-3">Other legal requirements</h5>
              <p>
                The Company may disclose Your Personal Data in the good faith
                belief that such action is necessary to:
              </p>
              <ol type="I">
                <li>Comply with a legal obligation</li>
                <li>
                  Protect and defend the rights or property of the Company
                </li>
                <li>
                  Prevent or investigate possible wrongdoing in connection with
                  the Service
                </li>
                <li>
                  Protect the personal safety of Users of the Service or the
                  public
                </li>
                <li>Protect against legal liability</li>
              </ol>
              <h5 class="title is-5 mt-3">Security of Your Personal Data</h5>
              <p>
                The security of Your Personal Data is important to Us, but
                remember that no method of transmission over the Internet, or
                method of electronic storage is 100% secure. While We strive to
                use commercially acceptable means to protect Your Personal Data,
                We cannot guarantee its absolute security.
              </p>
              <h5 class="title is-5 mt-3">
                Detailed Information on the Processing of Your Personal Data
              </h5>
              <p>
                Service Providers have access to Your Personal Data only to
                perform their tasks on Our behalf and are obligated not to
                disclose or use it for any other purpose.
              </p>
              <h5 class="title is-5 mt-3">Analytics</h5>
              <p>
                We may use third-party Service providers to monitor and analyze
                the use of our Service.
              </p>
              <ol type="I">
                <li class="my-2">
                  <strong>Google Analytics</strong><br />
                  Google Analytics is a web analytics service offered by Google
                  that tracks and reports website traffic. Google uses the data
                  collected to track and monitor the use of our Service. This
                  data is shared with other Google services. Google may use the
                  collected data to contextualize and personalize the ads of its
                  own advertising network.<br />
                  You can opt-out of having made your activity on the Service
                  available to Google Analytics by installing the Google
                  Analytics opt-out browser add-on. The add-on prevents the
                  Google Analytics JavaScript (ga.js, analytics.js and dc.js)
                  from sharing information with Google Analytics about visits
                  activity.<br />
                  For more information on the privacy practices of Google,
                  please visit the Google Privacy &amp; Terms web page:&nbsp;<a
                    href="https://policies.google.com/privacy"
                    >https://policies.google.com/privacy</a
                  >
                </li>
                <li class="my-2">
                  <strong>Firebase</strong><br />
                  G Firebase is an analytics service provided by Google Inc.<br />
                  You may opt-out of certain Firebase features through your
                  mobile device settings, such as your device advertising
                  settings or by following the instructions provided by Google
                  in their Privacy Policy:&nbsp;<a
                    href="https://policies.google.com/privacy"
                    >https://policies.google.com/privacy</a
                  ><br />
                  We also encourage you to review the Google's policy for
                  safeguarding your data:&nbsp;<a
                    href="https://support.google.com/analytics/answer/6004245"
                    >https://support.google.com/analytics/answer/6004245</a
                  ><br />
                  For more information on what type of information Firebase
                  collects, please visit the Google Privacy &amp; Terms web
                  page:&nbsp;<a href="https://policies.google.com/privacy"
                    >https://policies.google.com/privacy</a
                  >
                </li>
              </ol>
              <h4 class="title is-4 mt-4">Email Marketing</h4>
              <p>
                We may use Your Personal Data to contact You with newsletters,
                marketing or promotional materials and other information that
                may be of interest to You. You may opt-out of receiving any, or
                all, of these communications from Us by following the
                unsubscribe link or instructions provided in any email We send
                or by contacting Us.
              </p>
              <p>
                We may use Email Marketing Service Providers to manage and send
                emails to You.
              </p>
              <ol type="I">
                <li class="my-2">
                  <strong>Mailchimp</strong><br />
                  Mailchimp is an email marketing sending service provided by
                  The Rocket Science Group LLC.<br />
                  For more information on the privacy practices of Mailchimp,
                  please visit their Privacy policy:&nbsp;<a
                    href="https://mailchimp.com/legal/privacy/"
                    >https://mailchimp.com/legal/privacy/</a
                  >
                </li>
                <li class="my-2">
                  <strong>AWeber</strong><br />
                  AWeber is an email marketing sending service provided by
                  AWeber Communications.<br />
                  For more information on the privacy practices of AWeber,
                  please visit their Privacy policy:&nbsp;<a
                    href="https://www.aweber.com/privacy.htm"
                    >https://www.aweber.com/privacy.htm</a
                  >
                </li>
              </ol>
              <h4 class="title is-4 mt-4">Behavioral Remarketing</h4>
              <p>
                The Company uses remarketing services to advertise on third
                party websites to You after You visited our Service. We and Our
                third-party vendors use cookies to inform, optimize and serve
                ads based on Your past visits to our Service.
              </p>
              <ol type="I">
                <li class="my-2">
                  <strong>Google Ads (AdWords)</strong><br />
                  Google Ads (AdWords) remarketing service is provided by Google
                  Inc.<br />
                  You can opt-out of Google Analytics for Display Advertising
                  and customise the Google Display Network ads by visiting the
                  Google Ads Settings page:&nbsp;<a
                    href="http://www.google.com/settings/ads"
                    >http://www.google.com/settings/ads</a
                  ><br />
                  Google also recommends installing the Google Analytics Opt-out
                  Browser Add-on -&nbsp;<a
                    href="https://tools.google.com/dlpage/gaoptout"
                    >https://tools.google.com/dlpage/gaoptout</a
                  >&nbsp;- for your web browser.<br />
                  For more information on the privacy practices of Google,
                  please visit the Google Privacy &amp; Terms web page:&nbsp;<a
                    href="https://policies.google.com/privacy"
                    >https://policies.google.com/privacy</a
                  >
                </li>
                <li class="my-2">
                  <strong>Facebook</strong><br />
                  Facebook remarketing service is provided by Facebook Inc.<br />
                  You can learn more about interest-based advertising from
                  Facebook by visiting this page:&nbsp;<a
                    href="https://www.facebook.com/help/164968693837950"
                    >https://www.facebook.com/help/164968693837950</a
                  ><br />
                  To opt-out from Facebook's interest-based ads, follow these
                  instructions from Facebook:&nbsp;<a
                    href="https://www.facebook.com/help/568137493302217"
                    >https://www.facebook.com/help/568137493302217</a
                  ><br />
                  Facebook adheres to the Self-Regulatory Principles for Online
                  Behavioural Advertising established by the Digital Advertising
                  Alliance. You can also opt-out from Facebook and other
                  participating companies through the Digital Advertising
                  Alliance in the USA
                  <a href="http://www.aboutads.info/choices/"
                    >http://www.aboutads.info/choices/</a
                  >
                  , the Digital Advertising Alliance of Canada in Canada&nbsp;<a
                    href="http://youradchoices.ca/"
                    >http://youradchoices.ca/</a
                  >
                  &nbsp;or the European Interactive Digital Advertising Alliance
                  in Europe&nbsp;<a href="http://www.youronlinechoices.eu/"
                    >http://www.youronlinechoices.eu/</a
                  >, or opt-out using your mobile device settings.<br />
                  For more information on the privacy practices of Facebook,
                  please visit Facebook's Data Policy:&nbsp;<a
                    href="https://www.facebook.com/privacy/explanation"
                    >https://www.facebook.com/privacy/explanation</a
                  >
                </li>
              </ol>
            </div>
            <div>
              <h3 class="title is-3 mt-5">CCPA Privacy</h3>
              <h4 class="title is-4 mt-4">Your Rights under the CCPA</h4>
              <p>
                Under this Privacy Policy, and by law if You are a resident of
                California, You have the following rights:
              </p>
              <ol type="I">
                <li class="my-2">
                  <strong>The right to notice.</strong>&nbsp;You must be
                  properly notified which categories of Personal Data are being
                  collected and the purposes for which the Personal Data is
                  being used.
                </li>
                <li class="my-2">
                  <strong>The right to access / the right to request.</strong
                  >&nbsp;The CCPA permits You to request and obtain from the
                  Company information regarding the disclosure of Your Personal
                  Data that has been collected in the past 12 months by the
                  Company or its subsidiaries to a third-party for the third
                  party's direct marketing purposes.
                </li>
                <li class="my-2">
                  <strong
                    >The right to say no to the sale of Personal Data.</strong
                  >&nbsp;You also have the right to ask the Company not to sell
                  Your Personal Data to third parties. You can submit such a
                  request by visiting our "Do Not Sell My Personal Information"
                  section or web page.
                </li>
                <li class="my-2">
                  <strong>The right to know about Your Personal Data.</strong
                  >&nbsp;You have the right to request and obtain from the
                  Company information regarding the disclosure of the following:
                  <ol type="i">
                    <li>The categories of Personal Data collected</li>
                    <li>
                      The sources from which the Personal Data was collected
                    </li>
                    <li>
                      The business or commercial purpose for collecting or
                      selling the Personal Data
                    </li>
                    <li>
                      Categories of third parties with whom We share Personal
                      Data
                    </li>
                    <li>
                      The specific pieces of Personal Data we collected about
                      You
                    </li>
                  </ol>
                </li>
                <li class="my-2">
                  <strong>The right to delete Personal Data.</strong>
                  You also have the right to request the deletion of Your
                  Personal Data that have been collected in the past 12 months.
                </li>
                <li class="my-2">
                  <strong>The right not to be discriminated against.</strong>
                  You have the right not to be discriminated against for
                  exercising any of Your Consumer's rights, including by:
                  <ol type="i">
                    <li>Denying goods or services to You</li>
                    <li>
                      Charging different prices or rates for goods or services,
                      including the use of discounts or other benefits or
                      imposing penalties
                    </li>
                    <li>
                      Providing a different level or quality of goods or
                      services to You
                    </li>
                    <li>
                      Suggesting that You will receive a different price or rate
                      for goods or services or a different level or quality of
                      goods or services.
                    </li>
                  </ol>
                </li>
              </ol>
              <h4 class="title is-4 mt-4">
                Exercising Your CCPA Data Protection Rights
              </h4>
              <p>
                In order to exercise any of Your rights under the CCPA, and if
                you are a California resident, You can email or call us or visit
                our "Do Not Sell My Personal Information" section or web page.
              </p>
              <p>
                The Company will disclose and deliver the required information
                free of charge within 45 days of receiving Your verifiable
                request. The time period to provide the required information may
                be extended once by an additional 45 days when reasonable
                necessary and with prior notice.
              </p>
              <h4 class="title is-4 mt-4">
                Do Not Sell My Personal Information
              </h4>
              <p>
                We do not sell personal information. However, the Service
                Providers we partner with (for example, our advertising
                partners) may use technology on the Service that "sells"
                personal information as defined by the CCPA law.
              </p>
              <p>
                If you wish to opt out of the use of your personal information
                for interest-based advertising purposes and these potential
                sales as defined under CCPA law, you may do so by following the
                instructions below.
              </p>
              <p>
                Please note that any opt out is specific to the browser You use.
                You may need to opt out on every browser that you use.
              </p>
              <h5 class="title is-5 mt-3">Website</h5>
              You can opt out of receiving ads that are personalized as served
              by our Service Providers by following our instructions presented
              on the Service:
              <ol type="I">
                <li>From Our "Cookie Consent" notice banner</li>
                <li>Or from Our "CCPA Opt-out" notice banner</li>
                <li>
                  Or from Our "Do Not Sell My Personal Information" notice
                  banner
                </li>
                <li>Or from Our "Do Not Sell My Personal Information" link</li>
              </ol>
              The opt out will place a cookie on Your computer that is unique to
              the browser You use to opt out. If you change browsers or delete
              the cookies saved by your browser, you will need to opt out again.
              <h5 class="title is-5 mt-3">Mobile Devices</h5>
              Your mobile device may give you the ability to opt out of the use
              of information about the apps you use in order to serve you ads
              that are targeted to your interests:
              <ol type="I">
                <li>
                  "Opt out of Interest-Based Ads" or "Opt out of Ads
                  Personalization" on Android devices
                </li>
                <li>"Limit Ad Tracking" on iOS devices</li>
              </ol>
              You can also stop the collection of location information from Your
              mobile device by changing the preferences on your mobile device.
            </div>
            <div>
              <h3 class="title is-3 mt-5">
                "Do Not Track" Policy as Required by California Online Privacy
                Protection Act (CalOPPA)
              </h3>
              <p>Our Service does not respond to Do Not Track signals.</p>
              <p>
                However, some third party websites do keep track of Your
                browsing activities. If You are visiting such websites, You can
                set Your preferences in Your web browser to inform websites that
                You do not want to be tracked. You can enable or disable DNT by
                visiting the preferences or settings page of Your web browser.
              </p>
            </div>
            <div>
              <h3 class="title is-3 mt-5">"Children's Privacy</h3>
              <p>
                The Service may contain content appropriate for children under
                the age of 13. As a parent, you should know that through the
                Service children under the age of 13 may participate in
                activities that involve the collection or use of personal
                information. We use reasonable efforts to ensure that before we
                collect any personal information from a child, the child's
                parent receives notice of and consents to our personal
                information practices.
              </p>
              <p>
                We also may limit how We collect, use, and store some of the
                information of Users between 13 and 18 years old. In some cases,
                this means We will be unable to provide certain functionality of
                the Service to these Users. If We need to rely on consent as a
                legal basis for processing Your information and Your country
                requires consent from a parent, We may require Your parent's
                consent before We collect and use that information.
              </p>
              <p>
                We may ask a User to verify its date of birth before collecting
                any personal information from them. If the User is under the age
                of 13, the Service will be either blocked or redirected to a
                parental consent process.
              </p>
              <h4 class="title is-4 mt-4">
                Information Collected from Children Under the Age of 13
              </h4>
              <p>
                The Company may collect and store persistent identifiers such as
                cookies or IP addresses from Children without parental consent
                for the purpose of supporting the internal operation of the
                Service.
              </p>
              <p>
                We may collect and store other personal information about
                children if this information is submitted by a child with prior
                parent consent or by the parent or guardian of the child.
              </p>
              <p>
                The Company may collect and store the following types of
                personal information about a child when submitted by a child
                with prior parental consent or by the parent or guardian of the
                child:
              </p>
              <ol type="I">
                <li>First and/or last name</li>
                <li>Date of birth</li>
                <li>Gender</li>
                <li>Grade level</li>
                <li>Email address</li>
                <li>Telephone number</li>
                <li>Parent's or guardian's name</li>
                <li>Parent's or guardian's email address</li>
              </ol>
              <p>
                For further details on the information We might collect, You can
                refer to the "Types of Data Collected" section of this Privacy
                Policy. We follow our standard Privacy Policy for the disclosure
                of personal information collected from and about children.
              </p>
              <h4 class="title is-4 mt-4">Parental Access</h4>
              <p>
                A parent who has already given the Company permission to collect
                and use his child personal information can, at any time:
              </p>
              <ol type="i">
                <li>
                  Review, correct or delete the child's personal information
                </li>
                <li>
                  DDiscontinue further collection or use of the child's personal
                  information
                </li>
              </ol>
              <p>
                To make such a request, You can write to Us using the contact
                information provided in this Privacy Policy.
              </p>
            </div>
            <div>
              <h3 class="title is-3 mt-5">
                "Your California Privacy Rights (California's Shine the Light
                law)
              </h3>
              <p>
                Under California Civil Code Section 1798 (California's Shine the
                Light law), California residents with an established business
                relationship with us can request information once a year about
                sharing their Personal Data with third parties for the third
                parties' direct marketing purposes.
              </p>
              <p>
                If you'd like to request more information under the California
                Shine the Light law, and if you are a California resident, You
                can contact Us using the contact information provided below.
              </p>
            </div>
            <div>
              <h3 class="title is-3 mt-5">
                "California Privacy Rights for Minor Users (California Business
                and Professions Code Section 22581)
              </h3>
              <p>
                California Business and Professions Code section 22581 allow
                California residents under the age of 18 who are registered
                users of online sites, services or applications to request and
                obtain removal of content or information they have publicly
                posted.
              </p>
              <p>
                To request removal of such data, and if you are a California
                resident, You can contact Us using the contact information
                provided below, and include the email address associated with
                Your account.
              </p>
              <p>
                Be aware that Your request does not guarantee complete or
                comprehensive removal of content or information posted online
                and that the law may not permit or require removal in certain
                circumstances.
              </p>
            </div>
            <div>
              <h3 class="title is-3 mt-5">Links to Other Websites</h3>
              <p>
                Our Service may contain links to other websites that are not
                operated by Us. If You click on a third party link, You will be
                directed to that third party's site. We strongly advise You to
                review the Privacy Policy of every site You visit.
              </p>
              <p>
                We have no control over and assume no responsibility for the
                content, privacy policies or practices of any third party sites
                or services.
              </p>
            </div>
            <div>
              <h3 class="title is-3 mt-5">Changes to this Privacy Policy</h3>
              <p>
                We may update our Privacy Policy from time to time. We will
                notify You of any changes by posting the new Privacy Policy on
                this page.
              </p>
              <p>
                We will let You know via email and/or a prominent notice on Our
                Service, prior to the change becoming effective and update the
                "Last updated" date at the top of this Privacy Policy.
              </p>
              <p>
                You are advised to review this Privacy Policy periodically for
                any changes. Changes to this Privacy Policy are effective when
                they are posted on this page.
              </p>
            </div>
            <div>
              <h3 class="title is-3 mt-5">Contact Us</h3>
              <p>
                If you have any questions about this Privacy Policy, You can
                contact us:
              </p>
              <ul>
                <li>By email:&nbsp;hi@kidstopia-us.com</li>
              </ul>
            </div> -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { policyPrivacy } from "@/server/api.js";
import store from "@/store";

export default {
  components: {},
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  data() {
    return {
      data: {},
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      try {
        const { status, data } = await policyPrivacy({
        });
        if (status == 0) {
          this.data = data;
        }
      } catch (error) {}
    },
  },
};
</script>
<style scoped>
.section {
  padding: 3rem 1.5rem;
}
.privacy-header {
  background-color: #f5d784;
  margin-top: 50px;
}
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
.has-text-centered {
  text-align: center !important;
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}
.title.is-1 {
  font-size: 3rem;
}
.title:not(.is-spaced) + .subtitle {
  margin-top: -1.25rem;
}

.has-text-weight-medium {
  font-weight: 500 !important;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}
.tabs:not(:last-child),
.pagination:not(:last-child),
.message:not(:last-child),
.level:not(:last-child),
.breadcrumb:not(:last-child),
.block:not(:last-child),
.title:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.progress:not(:last-child),
.notification:not(:last-child),
.content:not(:last-child),
.box:not(:last-child) {
  margin-bottom: 1.5rem;
}
.columns.is-mobile > .column.is-10 {
  flex: none;
  width: 83.33333337%;
}
.columns.is-centered {
  justify-content: center;
}
@media screen and (min-width: 769px), print {
  .columns:not(.is-desktop) {
    display: flex;
  }
  .column.is-full,
  .column.is-full-tablet {
    flex: none;
    width: 100%;
  }
  .column.is-10,
  .column.is-10-tablet {
    flex: none;
    width: 83.33333337%;
  }
}
@media screen and (min-width: 1024px) {
  .section {
    padding: 3rem;
  }
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/policy/privacy.vue